function ConfAppResAddress(props) {
  let resAddress = getResAddress(props.res_address);

  return (
    <div id="confidential-residential-address">
      <div className="row">
        <div className="col-lg-9 col-sm-12">
          <h3 id="conf_resaddress_text">Residential Address</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-md-3 col-sm-12" id="add">
          <strong id="adrs">Address</strong>
        </div>

        <div
          id="residential_address"
          className="col-lg-9 col-md-9 col-sm-12 data"
        >
          {resAddress}
        </div>
      </div>
    </div>
  );
}

function getResAddress(residentialAddress) {
  try {
    let resAddress = "";
    const { address1, address2, city, state, zip, resurbanization } =
      residentialAddress;
    const isThereUrbanization =
      resurbanization !== undefined &&
      resurbanization !== "" &&
      resurbanization !== null;

    resAddress = `
    ${state === "PR" && isThereUrbanization ? `${resurbanization}, ` : ""}
    ${address1}, ${
      address2 === "" ? "" : `${address2}, `
    }${city}, ${state}, ${zip}`;

    return resAddress;
  } catch (e) {
    console.log(e);
    return { error: "error with residential address" };
  }
}

export default ConfAppResAddress;
